import { Text, Timestamp } from '@dixa/lib-shared-habla';

import { useConversationRow } from '../../../utils/useConversationRow';

export const ConversationsTableFollowUp = (): JSX.Element | null => {
  const { conversation } = useConversationRow();
  const pendingExpirationAt = conversation.pending_expiration_at;

  if (!pendingExpirationAt) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  return (
    <Timestamp
      time={pendingExpirationAt}
      relative
      onClick={(_format, event) => event.stopPropagation()}
    />
  );
};
